import pl from "vee-validate/dist/locale/pl";

export default {
  pl: {
    custom: {
      username: {
        required: "Uzytkownik jest wymagany"
      },
      password: {
        required: "Hasło jest wymagane"
      }
    },
    messages: pl.messages
  }
};



// WEBPACK FOOTER //
// ./src/app/validators/messages.js